import {
    InvalidReasons,
    Routes
} from '../components/ClientExperience/GiftCard/stores/instant-pay.store';
import { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { TRootStore } from '~/types/app.types';

export function instantPayScreenAnalyticsName(
    activeRoute: Routes,
    invalidReason: InvalidReasons
) {
    switch (activeRoute) {
        case Routes.CheckoutForm:
            return 'regular';
        case Routes.LoadError:
            return 'error';
        case Routes.ThankYou:
            return invalidReason || 'success';
        default:
            return '';
    }
}

export function getForterToken() {
    const value = `; ${document.cookie}`;
    const parts = value.split('; forterToken=');
    if (parts.length > 1) {
        return parts.pop().split(';').shift();
    }
    return '';
}

export function getAuthHashUrlParameter() {
    const { searchParams } = new URL(window.location.href);
    return getAuthHashUrlParameterFromSearchParam(searchParams);
}

export function getAuthHashUrlParameterFromSearchParam(searchParams) {
    return searchParams.get('hash');
}

export function setTitleAndFavicon(title, faviconUrl) {
    // set title
    if (title) {
        document.title = title;
    }
    // set favicon
    if (faviconUrl) {
        const link: HTMLLinkElement =
            document.querySelector("link[rel*='icon']") ||
            document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = faviconUrl;
        document.getElementsByTagName('head')[0].appendChild(link);
    }
}

export function getPageRoute(pageIndex: number, title: string) {
    return `${pageIndex + 1}-${title
        .replace(/\s/g, '_')
        .replace(/[^\w]/g, '')}`;
}

export function isCX(_rootStore: TRootStore): _rootStore is CXRootStore {
    return _rootStore && !('builderUiStore' in _rootStore);
}

export function getClientPortalConfiguration() {
    if (window && window.clientPortalConfiguration) {
        return window.clientPortalConfiguration;
    }
    return null;
}
